import React, { FC, useState } from 'react';
import './pagination.sass';
import Button from '../../../../shared/components/button/button';
export interface IPaginationProps {
  onNewContent?: () => void;
  fetchNextPage: (isPagination?: boolean) => void;
  fetchPrevPage: (isPagination?: boolean) => void;
  isPostsFetched: boolean;
}

export const Pagination: FC<IPaginationProps> = ({ onNewContent, fetchPrevPage, fetchNextPage, isPostsFetched }) => {
  const [pageCounter, setPageCounter] = useState(0);

  const handlePreviousPage = () => {
    if (onNewContent) {
      onNewContent();
    }
    fetchPrevPage(true);
    setPageCounter(pageCounter - 1);
  };

  const handleNextPage = () => {
    if (onNewContent) {
      onNewContent();
    }
    fetchNextPage(true);
    setPageCounter(pageCounter + 1);
  };

  return (
    <>
      <Button
        onClick={handlePreviousPage}
        className="pagination"
        style={{ display: pageCounter === 0 ? 'none' : 'block' }}
      >
        Prev
      </Button>
      <Button onClick={handleNextPage} className="pagination" style={{ display: isPostsFetched ? 'none' : 'block' }}>
        Next
      </Button>
    </>
  );
};

export default Pagination;
